import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { formatDateToShortString } from '../../../common/common';
import { useSelector } from 'react-redux';

const CustomerPopupWithOrder = ({ isOpen, onClose, order_details_id, sku, isSingleExclude, isBoth, productList }) => {
    const [loadingdata, setLoadingdata] = useState(false);
    const navigate = useNavigate();
    const currentAnalysisData = useSelector((state) => state.analysisData.currentAnalysisData);
    const [originalCustomerResponse, setOriginalCustomerResponse] = useState({});
    const [customerResponse, setCustomerResponse] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const [customerData, setCustomerData] = useState([])

    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageForCustomer, setCurrentPageForCustomer] = useState(1);

    const itemsPerPage = 5;

    const getCustomerData = async () => {
        try {
            setLoadingdata(true);
            const params = new URLSearchParams({ order_details_id: order_details_id, isSingleExclude: isSingleExclude,isExcludeCancelOrder: currentAnalysisData.isExcludeCancelOrder === undefined ? false : currentAnalysisData.isExcludeCancelOrder });
            let finalSku = [];
            if (isBoth.antecedent) {
                finalSku = [...sku.antecedentSKU]
            } else if (isBoth.consequent) {
                finalSku = [...sku.consequentSKU]
            } else {
                finalSku = [...sku.allSku]
            }
            finalSku.forEach((sku) => params.append("sku", sku)); // Appends multiple sku=...

            const url = `${process.env.REACT_APP_API_END_POINT}/data-analysis/customers-details?${params.toString()}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });

            const data = await response.json();
            if (!response.ok) {
                if (data.detail.isExpireToken) {
                    const token = localStorage.removeItem("token");
                    const user = localStorage.removeItem("userInfo");
                    navigate("/login")
                }
                throw new Error(data.detail?.message || 'Failed to fetch orders');
            }

            const groupedRaw = data.data.reduce((acc, item) => {
                const id = item.order_id;
                if (!acc[id]) acc[id] = [];
                acc[id].push(item);
                return acc;
            }, {});


            const filteredGrouped = Object.entries(groupedRaw).reduce((acc, [orderId, items]) => {
                const skusInOrder = items.map(i => i.sku.toLowerCase());
                const hasAllRequiredSkus = finalSku.every(sku => skusInOrder.includes(sku.toLowerCase()));

                if (hasAllRequiredSkus) {
                    // Extract customer & order info from first item
                    const { customerId, customerFirstName, customerLastName, customerPhone, order_id, customerEmail, order_created_at } = items[0];

                    // Map all products
                    const products = items.map(({ sku, product_name, product_image }) => ({
                        sku,
                        product_name,
                        product_image
                    }));

                    acc[orderId] = {
                        customerId,
                        customerFirstName,
                        customerLastName,
                        customerEmail,
                        customerPhone,
                        order_id,
                        products,
                        order_created_at
                    };
                }

                return acc;
            }, {});

            // console.log("test-Filtered Orders (with all SKUs):", filteredGrouped);
            // console.log("test-Total Valid Order IDs:", Object.keys(filteredGrouped).length);

            const arrayData = Object.values(filteredGrouped);
            // 🔍 Filter unique by customerId
            const uniqueByCustomerId = Array.from(
                new Map(arrayData.map(item => [item.customerId, item])).values()
            );
            setCustomerData(uniqueByCustomerId)

            setCustomerResponse(filteredGrouped)
            setOriginalCustomerResponse(filteredGrouped)

        } catch (err) {
            toast.error(err.message, {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setLoadingdata(false)
        }
    };


    useEffect(() => {
        if (isOpen) {
            setCurrentPage(1);
            // if (originalCustomerResponse.length === 0) {
            getCustomerData();
            // }
        }
    }, [isOpen]);

    useEffect(() => {
        if (!searchTerm.trim()) {
            setCustomerResponse(originalCustomerResponse); // Reset
            return;
        }

        const lower = searchTerm.toLowerCase();

        // `originalCustomerResponse` is an object, so we need to convert it to array first
        const filtered = Object.entries(originalCustomerResponse)
            .filter(([orderId, customer]) => {
                const fullName = `${customer.customerFirstName ?? ''} ${customer.customerLastName ?? ''}`.trim().toLowerCase();

                return (
                    fullName.includes(lower) ||
                    customer.customerPhone?.toLowerCase().includes(lower) ||
                    customer.customerEmail?.toLowerCase().includes(lower) ||
                    customer.order_id?.toLowerCase().includes(lower)
                );
            })
            .reduce((acc, [orderId, data]) => {
                acc[orderId] = data;
                return acc;
            }, {});

        setCustomerResponse(filtered);
    }, [searchTerm]);

    // Pagination logic
    const groupedArray = Object.entries(customerResponse);
    const totalPages = Math.ceil(groupedArray.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedGroups = groupedArray.slice(startIndex, startIndex + itemsPerPage);


    // Pagination logic
    const totalPagesForCustomer = Math.ceil(customerData.length / itemsPerPage);
    const startIndexForCustomer = (currentPageForCustomer - 1) * itemsPerPage;
    const paginatedGroupsForCustomer = customerData.slice(startIndexForCustomer, startIndexForCustomer + itemsPerPage);

    if (!isOpen) return null;


    return (
        <div className="fixed w-full inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center">

            <div className="bg-white w-full max-w-7xl max-h-[90vh] rounded-lg shadow-lg flex flex-col">
            <div className="flex items-center justify-between border-b px-4 py-3 bg-white shadow-sm">
            <h1 className="text-lg font-semibold text-gray-800">
                🧾 Order & Customer Information
            </h1>
            <button
                onClick={onClose}
                className="text-gray-500 hover:text-red-500 text-2xl font-bold transition duration-200"
                aria-label="Close"
            >
                &times;
            </button>
            </div>
                {loadingdata &&
                    <div className="flex items-center justify-center min-h-[200px]">
                        <div className="flex flex-col items-center space-y-2">
                            <div className="w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
                            <p className="text-gray-600 text-sm">Loading...</p>
                        </div>
                    </div>
                }

                {
                    !loadingdata &&
                    <div class="container mx-auto px-4 py-8">



                        <div class="flex flex-col md:flex-row items-center justify-center gap-6 mb-8 p-4  rounded-xl border border-gray-200 wiggle-animation">
                        {(
                            isBoth.all
                                ? [...productList.antecedents, ...productList.consequent]
                                : isBoth.antecedent
                                ? productList.antecedents
                                : isBoth.consequent
                                ? productList.consequent
                                : []
                            ).map((product, index, arr) => (
                            <div key={index} className="flex items-center gap-3">
                                <div className="w-16 h-16">
                                <img
                                    className="w-10 h-10 rounded-full border-2 border-white shadow"
                                    src={product.image || "/noimage.jpg"}
                                    alt={product.product_name || "Product"}
                                />
                                </div>
                                <div>
                                <p className="font-medium">{product.product_title}</p>
                                <p className="text-gray-500 text-sm">• {product.sku}</p>
                                </div>

                                {/* Plus icon except after last item */}
                                {index !== arr.length - 1 && (
                                <div className="text-gray-400">
                                    <i className="fas fa-plus text-xl"></i>
                                </div>
                                )}
                            </div>
                            ))}
                        </div>
                        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
                            {/* Customers Who Bought Both */}
                            <div className=" ">
                                <div className="flex justify-between items-center mb-4">
                                    <h2 className="text-xl font-semibold text-gray-800 px-3 ">
                                        <i class="fas fa-users text-green-500 mr-2"></i> Customers Who Bought Together
                                    </h2>
                                    <span className="bg-indigo-100 text-indigo-800 text-xs px-3 py-1 rounded-full">
                                        {customerData.length} customers
                                    </span>
                                </div>
                                <hr />
                                <div className="space-y-4">
                                    {paginatedGroupsForCustomer.length > 0 && paginatedGroupsForCustomer.map((customer, idx) => (
                                        <div
                                            key={idx}
                                            className="flex items-center p-3 border-b border-gray-100 hover:bg-gray-50 rounded-lg transition-all"
                                        >
                                            <img
                                                className="w-10 h-10 rounded-full"
                                                src={"sample-person.jpg"}
                                            // alt={customer.name}
                                            />
                                            <div className="ml-4">
                                                <p className="font-medium text-gray-800">{customer.customerFirstName} {customer.customerLastName}</p>
                                                <div className="flex items-center text-sm text-gray-500">
                                                    <span className="mr-3">#{customer.customerId}</span>
                                                    {/* <i className="fas fa-shopping-basket mr-1 text-indigo-500"></i>
                                                <span>{customer.orders} orders</span> */}
                                                </div>
                                            </div>
                                            <div className="ml-auto text-right">
                                                <p className="text-sm font-medium text-gray-700">
                                                    {customer.customerEmail ? customer.customerEmail : "N/A"}
                                                </p>
                                                <button className="text-indigo-600 text-sm hover:text-indigo-800">
                                                    {customer.customerPhone ? customer.customerPhone : "N/A"}
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                    {
                                        totalPagesForCustomer > 1 &&
                                        <div className="p-4 border-t flex justify-between items-center bg-gray-50 flex-wrap gap-2">
                                            <button
                                                onClick={() => setCurrentPageForCustomer(prev => Math.max(prev - 1, 1))}
                                                disabled={currentPageForCustomer === 1}
                                                className="px-3 py-1 text-sm bg-gray-200 text-gray-700 rounded disabled:opacity-50"
                                            >
                                                Previous
                                            </button>

                                            <div className="flex items-center space-x-1">
                                            {[
  ...new Set(
    Array.from({ length: totalPagesForCustomer }, (_, i) => i + 1)
      .filter((page) =>
        page === 1 ||
        page === totalPagesForCustomer ||
        Math.abs(page - currentPageForCustomer) <= 1
      )
      .reduce((acc, page, idx, arr) => {
        if (idx > 0 && page - arr[idx - 1] > 1) {
          acc.push("ellipsis");
        }
        acc.push(page);
        return acc;
      }, [])
  )
].map((page, idx) =>
  page === "ellipsis" ? (
    <span key={idx} className="px-2 text-gray-500">...</span>
  ) : (
    <button
      key={page}
      onClick={() => setCurrentPageForCustomer(page)}
      className={`px-3 py-1 text-sm rounded ${currentPageForCustomer === page
        ? "bg-blue-500 text-white"
        : "bg-gray-200 text-gray-700"
        }`}
    >
      {page}
    </button>
  )
)}
                                            </div>

                                            <button
                                                onClick={() => setCurrentPageForCustomer(prev => Math.min(prev + 1, totalPages))}
                                                disabled={currentPage === totalPages}
                                                className="px-3 py-1 text-sm bg-gray-200 text-gray-700 rounded disabled:opacity-50"
                                            >
                                                Next
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>

                            {/* Recent Combination Orders */}
                            <div className=" ">
                                <div className="flex justify-between items-center mb-4">
                                    <h2 className="text-xl font-semibold text-gray-800  px-3">
                                        <i class="fas fa-shopping-basket text-indigo-500 mr-2"></i> Order Detail Of Combination
                                    </h2>
                                    <span className="bg-indigo-100 text-indigo-800 text-xs px-3 py-1 rounded-full">
                                        {groupedArray.length} orders
                                    </span>
                                </div>
                                <hr />
                                <div className="space-y-4">
                                    {paginatedGroups.length > 0 && paginatedGroups.map(([orderId, items], index) => (
                                        <div
                                            // key={idx}
                                            className="flex items-center p-3 border-b border-gray-100 hover:bg-gray-50 rounded-lg transition-all"
                                        >

                                            <div className="bg-indigo-100 p-2 rounded-lg">
                                                <i className="fas fa-receipt text-indigo-600"></i>
                                            </div>
                                            <div className="ml-4">
                                                <p className="font-medium text-gray-800">
                                                    Order #{orderId}
                                                </p>
                                                <div className="flex items-center text-sm text-gray-500">
                                                    <span className="mr-3">{items.customerFirstName} {items.customerLastName}</span>
                                                    {/* <i className={`${order.icon} mr-1`}></i> */}
                                                    {/* <span>{order.status}</span> */}
                                                </div>
                                            </div>
                                            <div className="ml-auto text-right">
                                                {/* <p className="text-sm font-medium">{order.amount}</p> */}
                                                <p className="text-xs text-gray-500">{formatDateToShortString(items.order_created_at)}</p>
                                            </div>
                                        </div>
                                    ))}
                                    {
                                        totalPages > 1 &&
                                        <div className="p-4 border-t flex justify-between items-center bg-gray-50 flex-wrap gap-2">
                                            <button
                                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                disabled={currentPage === 1}
                                                className="px-3 py-1 text-sm bg-gray-200 text-gray-700 rounded disabled:opacity-50"
                                            >
                                                Previous
                                            </button>

                                            <div className="flex items-center space-x-1">
                                            {[...new Set(
                                                Array.from({ length: totalPages }, (_, i) => i + 1)
                                                    .filter((page) =>
                                                        page === 1 ||
                                                        page === totalPages ||
                                                        Math.abs(page - currentPage) <= 1
                                                    )
                                                    .reduce((acc, page, idx, arr) => {
                                                        if (idx > 0 && page - arr[idx - 1] > 1) {
                                                            acc.push("ellipsis");
                                                        }
                                                        acc.push(page);
                                                        return acc;
                                                    }, [])
                                            )].map((page, idx) =>
                                                page === "ellipsis" ? (
                                                    <span key={idx} className="px-2 text-gray-500">...</span>
                                                ) : (
                                                    <button
                                                        key={page}
                                                        onClick={() => setCurrentPage(page)}
                                                        className={`px-3 py-1 text-sm rounded ${currentPage === page
                                                            ? "bg-blue-500 text-white"
                                                            : "bg-gray-200 text-gray-700"
                                                            }`}
                                                    >
                                                        {page}
                                                    </button>
                                                )
                                            )}
                                            </div>

                                            <button
                                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                                disabled={currentPage === totalPages}
                                                className="px-3 py-1 text-sm bg-gray-200 text-gray-700 rounded disabled:opacity-50"
                                            >
                                                Next
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div >
    );
};

export default CustomerPopupWithOrder;
